import { Union } from 'ts-toolbelt';

const DEFAULT_DIVIDER = ', ';

export interface Location {
  city?: Union.Nullable<string>;
  street?: Union.Nullable<string>;
  // sometimes the street field is called address
  address?: Union.Nullable<string>;
  postalCode?: Union.Nullable<string>;
  countryCode?: Union.Nullable<string>;
}

export interface LocationLabelOptions {
  divider?: string | null;
}

export const locationLabel =
  (t: (key: string) => string) =>
  (value: Union.Nullable<Location>, options?: LocationLabelOptions): string | null => {
    if (value) {
      return [
        // street
        value.address?.trim(),
        value.street?.trim(),
        // zip city
        [value.postalCode?.trim(), value.city?.trim()].filter(Boolean).join(' '),
        // country countryCode
        value.countryCode && t(value.countryCode?.toUpperCase()),
      ]
        .filter(Boolean)
        .join(options?.divider || DEFAULT_DIVIDER);
    }
    return null;
  };
